module.exports = __webpack_public_path__ + "static/media/tastingnotes_venue.611ffd25.png";